export const NAVIGATION_TOGGLE_MENU = 'NAVIGATION_TOGGLE_MENU';
export const NAVIGATION_CHANGE_CATEGORY = 'NAVIGATION_CHANGE_CATEGORY';
export const NAVIGATION_OPEN_CATEGORY_LINK = 'NAVIGATION_OPEN_CATEGORY_LINK';

const toggleMenu = state => ({
  ...state,
  type: NAVIGATION_TOGGLE_MENU,
});

const changeCategory = state => ({
  ...state,
  type: NAVIGATION_CHANGE_CATEGORY,
});

const openCategoryLink = state => ({
  ...state,
  type: NAVIGATION_OPEN_CATEGORY_LINK,
});

export default {
  toggleMenu,
  changeCategory,
  openCategoryLink,
};
